<template>
  <Vfm :show="show" @onclose="handleClose" class="z-1000" :class="[show ? '' : 'none']">
    <div class="absolute t-0 l-0 r-0 b-0">
      <div class="w-full h-full bg-color-1">
        <Navbar
          title="Account"
          :back="false"
          @onback="handleClose"
          class="fixed t-0 l-0"
        />
        <!-- 表单 -->
        <div class="text-center relative">
          <section class="px-15">
            <h2 class="mt-15 mb-10 text-left text-color-1 text-12">
              {{ $t("A0300") }}
            </h2>
            <PhoneFormInput
              v-model="formData.account"
              :error="errors.account"
              type="text"
              :placeholder="$t('A0285')"
              @onblur="handleBlurAccount"
            />
          </section>
          <div class="fixed b-0 w-full z-1 px-15 py-20 bg-color-4 text-14">
            <button
              @click="handelSubmit"
              class="bg-color-main w-full text-color-white font-700 h-40 rounded-5"
            >
              {{ $t("A0297") }}
            </button>
          </div>
        </div>
      </div>
    </div>
  </Vfm>
</template>

<script setup>
import { ref, watch, onMounted, getCurrentInstance, computed } from "vue";
const { proxy } = getCurrentInstance();
import { apiEditUserinfo } from "@/api";
import { useUserStore } from "@/stores/modules/user";
import { useI18n } from "vue-i18n";
import Utils from "@/utils/util";
const { t } = useI18n();
const userStore = useUserStore();
const userinfo = computed(() => {
  return userStore.userinfo;
});
const props = defineProps({
  show: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(["onclose", "onsuccess"]);
const formData = ref({
  account: ""
});
const errors = ref({
  account: ""
});
watch(
  () => userinfo.value?.account,
  newValue => {
    formData.value.account = newValue || "";
  }
);
onMounted(() => {
  formData.value.account = userinfo.value?.account || "";
});

function handleClose() {
  emit("onclose");
}
function handleBlurAccount() {
  let isValid = true;
  if (!formData.value.account) {
    errors.value.account = t("A0285");
    isValid = false;
  } else if (!Utils.$checkAccount(formData.value.account)) {
    errors.value.account = t("A0301");
    isValid = false;
  } else {
    errors.value.account = "";
  }
  return isValid;
}

function validateForm() {
  let isValid = true;
  isValid = handleBlurAccount();
  return isValid;
}
async function handelSubmit() {
  if (validateForm()) {
    proxy.$Loading.show();
    try {
      const { code } = await apiEditUserinfo({
        account: formData.value.account
      });
      if (code === 200) {
        emit("onsuccess");
        handleClose();
      }
    } catch (error) {
    } finally {
      proxy.$Loading.hide();
    }
  }
}
</script>

<style lang="scss" scoped></style>
